export default import.meta.ROLLDOWN_FILE_URL_yfpHLMvVGeugh68pjJSSiA